export const AMAP_KEY = 'f0da9fb8263bb9b657e2257ec09c6df7'